import { styleObjectToCssText } from "../../lib/utils/styling";
import { arrayify } from "../../lib/utils/array";
import pickBy from "lodash-es/pickBy";
export var UCStyleSheetType;
(function (UCStyleSheetType) {
  UCStyleSheetType[UCStyleSheetType["Public"] = 0] = "Public";
  UCStyleSheetType[UCStyleSheetType["Private"] = 1] = "Private";
})(UCStyleSheetType || (UCStyleSheetType = {}));
export class UcCssGenerator {
  constructor(option) {
    this.sheets = (option === null || option === void 0 ? void 0 : option.sheets) || [];
  }
  init() {
    this.generate(this.sheets);
  }
  compile(sheets) {
    return ucStyleSheetToCssText(sheets);
  }
  generate(sheet) {
    const rapper = arrayify(sheet);
    const fragment = document.createDocumentFragment();
    rapper.forEach(singleSheet => {
      const dom = this.compile(singleSheet);
      if (dom) {
        // 保持domid唯一
        const existedDom = document.getElementById(dom.id);
        if (existedDom) {
          existedDom.remove();
        }
        fragment.appendChild(dom);
      }
    });
    document.body.appendChild(fragment);
  }
  patchStyle(sheet) {
    const sheetArray = arrayify(sheet);
    // 去重相同id或者是cnName的
    const sheetId = sheetArray.map(item => item.id);
    const sheetNames = sheetArray.filter(item => item.cnName).map(item => item.cnName);
    const sameNameSheetIds = this.sheets.filter(item => sheetNames.indexOf(item.cnName) !== -1).map(item => item.id);
    const willDeleteIds = [...sheetId, ...sameNameSheetIds];
    this.deleteStyle(willDeleteIds);
    const validSheet = sheetArray.filter(item => validStyleSheet(item));
    this.generate(validSheet);
    this.sheets = this.sheets.concat(validSheet);
  }
  deleteStyle(sheetId, sync = true) {
    const rapper = arrayify(sheetId);
    rapper.forEach(id => {
      var _this$sheets$index;
      const index = this.sheets.findIndex(sheet => sheet.id === id);
      const domId = (_this$sheets$index = this.sheets[index]) === null || _this$sheets$index === void 0 ? void 0 : _this$sheets$index.tagDomId;
      if (domId) {
        var _document$getElementB;
        (_document$getElementB = document.getElementById(domId)) === null || _document$getElementB === void 0 || _document$getElementB.remove();
        if (sync) {
          this.sheets = this.sheets.slice(0, index).concat(this.sheets.slice(index + 1));
        }
      }
    });
  }
  clean() {
    const sheetIds = this.sheets.map(item => item.id);
    this.deleteStyle(sheetIds, false);
  }
  getPublicSheets() {
    return this.sheets.filter(item => item.type == UCStyleSheetType.Public);
  }
  getSheets() {
    return this.sheets;
  }
}
function ucStyleSheetToCssText(styleObj) {
  const {
    type
  } = styleObj;
  const staticContent = styleObjectToCssText(pickBy(styleObj.style.static, v => v));
  const hoverContent = styleObjectToCssText(pickBy(styleObj.style.hover, v => v));
  // 空对象就删除dom
  if (!staticContent && !hoverContent) {
    var _document$getElementB2;
    (_document$getElementB2 = document.getElementById(styleObj.tagDomId)) === null || _document$getElementB2 === void 0 || _document$getElementB2.remove();
    return '';
  }
  const templates = `
      ${type === UCStyleSheetType.Private ? 'body ' : ''}.${styleObj.className}{
        ${staticContent}
      }
      ${type === UCStyleSheetType.Private ? 'body ' : ''}.${styleObj.className}:hover {
        ${hoverContent}
      }
    `;
  const styleDom = document.createElement('style');
  styleDom.id = styleObj.tagDomId;
  styleDom.innerHTML = templates;
  return styleDom;
}
export function validStyleSheet(sheet) {
  var _sheet$style, _sheet$style2;
  return Object.keys({
    ...(((_sheet$style = sheet.style) === null || _sheet$style === void 0 ? void 0 : _sheet$style.hover) || {}),
    ...(((_sheet$style2 = sheet.style) === null || _sheet$style2 === void 0 ? void 0 : _sheet$style2.static) || {})
  }).length > 0;
}
//# sourceMappingURL=ucCssGenerator.js.map
